import { SvgPath } from '@rbilabs/universal-components';
import { View, useWindowDimensions } from 'react-native';
import Svg from 'react-native-svg';

import { primitive } from 'styles/constants/primitives';

export const CurvedBackground = ({
  height,
  backgroundColor,
  curveColor = primitive.$white,
}: {
  height: number;
  backgroundColor: string;
  curveColor?: string;
}) => {
  const { width } = useWindowDimensions();
  return (
    <View style={{ position: 'absolute', backgroundColor }}>
      <Svg viewBox={`0 0 ${width} ${height}`} width={width} height={height}>
        <SvgPath
          fill={curveColor}
          d={`M0 ${height} H${width} V${height} C${0.8 * width} ${0.7 * height}, ${0.2 * width} ${
            0.7 * height
          }, 0 ${height}
      Z`}
        />
      </Svg>
    </View>
  );
};
